import io from 'socket.io-client';

export const appSocket = {
    //socket:io('https://api.recover.healthcare'),
    socket:io(process.env.REACT_APP_API_URL),
};
